import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import text from '../../../../text';
import Button from '../../../button/Button';
import List from '../../../list/List';
import { formatDate } from '../../../../utilities/date';
import { getUserMembership } from '../../../../utilities/user';
import { noop } from 'lodash';
import T from 'prop-types';
var StartTrialStatusStep = function(param) {
    var onNext = param.onNext, _param_callback = param.callback, callback = _param_callback === void 0 ? noop : _param_callback;
    var _getUserMembership, _getUserMembership1;
    var _useSelector = useSelector(function(state) {
        return {
            currentUser: state.profileReducer.userProfile,
            upsertMembership: state.profileReducer.upsertMembership
        };
    }), currentUser = _useSelector.currentUser, upsertMembership = _useSelector.upsertMembership;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement("h3", null, text('freeTrialHasStarted'))), /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement(List, {
        isBorderless: true
    }, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
        isColonAppended: true,
        description: text('startDateTrial'),
        value: formatDate((_getUserMembership = getUserMembership(currentUser)) === null || _getUserMembership === void 0 ? void 0 : _getUserMembership.start_date)
    }), /*#__PURE__*/ React.createElement(List.Item, {
        isColonAppended: true,
        description: text('endDateTrial'),
        value: formatDate((_getUserMembership1 = getUserMembership(currentUser)) === null || _getUserMembership1 === void 0 ? void 0 : _getUserMembership1.end_date)
    })))), /*#__PURE__*/ React.createElement(Modal.Footer, {
        className: "d-flex flex-column centered"
    }, /*#__PURE__*/ React.createElement(Button, {
        className: "full-width",
        loading: upsertMembership.isLoading,
        onClick: function() {
            onNext();
            if (callback) {
                callback();
            }
        },
        autoFocus: true
    }, text('continue'))));
};
StartTrialStatusStep.propTypes = {
    onNext: T.func,
    callback: T.func
};
export default StartTrialStatusStep;
